import { LoadingOverlay } from "@mantine/core";
import { theme } from "../../theme";

const CustomLoadingOverlay = ({ visible }: any) => {
  return (
    <LoadingOverlay
      visible={visible}
      zIndex={1000}
      overlayProps={{ blur: 2 }}
      loaderProps={{
        size: "xl",
        color: theme.colors.brand.normal,
        type: "oval",
      }}
    />
  );
};

export default CustomLoadingOverlay
